import BackButton from "../components/Buttons/BackButton";
import XsCont from "../components/containers/Xs";
import HeaderSignIn from "../components/headers/HeaderSignIn";
import { Box, Container, Typography } from "@mui/material";
import React, { FC } from "react";
import { useNavigate } from "react-router-dom";

const ErrorPage: FC = () => {
  const navigate = useNavigate();
  const handleButtonClick = () => {
    const loginId = sessionStorage.getItem("loginId");
    if (!loginId) {
      navigate("/signin");
      return;
    }
    navigate("/menu");
  };
  return (
    <>
      <HeaderSignIn />
      <Container maxWidth="lg">
        <Box mt={30} textAlign="center">
          <Typography variant="body1" gutterBottom>
            エラーが発生しました。最初からもう一度お試しください。
          </Typography>
        </Box>
      </Container>
      <XsCont>
        <BackButton onClick={handleButtonClick} mt={15}>
          戻る
        </BackButton>
      </XsCont>
    </>
  );
};

export default ErrorPage;
